// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page[data-v-655a81d0]{text-align:center;padding-top:5em}img[data-v-655a81d0]{max-width:100%}h1[data-v-655a81d0]{margin:1em 0;font-size:3em}p[data-v-655a81d0]{line-height:1.5em}button[data-v-655a81d0]{display:inline-block;background:none;border:1px solid #3760fb;font-size:17px;border-radius:4px;padding:1em 2em;cursor:pointer;margin:1em 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
